import { GET_SIGNED_URL } from '@/Graphql/queries';
import { useLazyQuery } from '@apollo/client';
import { useState } from 'react';

const useAwsUpload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [getSignedUrl] = useLazyQuery(GET_SIGNED_URL, {
    context: { clientName: 'userPermissions' },
  });
  const handleUploadError = (err: any) => {
    console.log(err);
    setError(err);
    setLoading(false);
    throw err;
  };
  const upload = async (selectedFile: any, fileType: any) => {
    try {
      setLoading(true);
      const { data } = await getSignedUrl({ variables: { fileName: selectedFile.name, fileType } });
      await awsUpload({ selectedFile, signedUrl: data?.getSignedUrl.url });
      setLoading(false);
      return data?.getSignedUrl;
    } catch (err) {
      handleUploadError(err);
      return null;
    }
  };
  return { upload, loading, error };
};
const awsUpload = async ({ selectedFile, signedUrl }: { selectedFile: any; signedUrl: any }) => {
  const res = await fetch(signedUrl, { method: 'PUT', body: selectedFile.file });
  return res;
};

export default useAwsUpload;
